export default __webpack_public_path__ + "static/media/nu.d8793864.png";